// eslint-disable-next-line import/no-cycle
import UBTHelper from './ubt';
import env from './env';

function createImgCompresser(file, options) {
  // 解决html5 image compress 中将webpack配置改变的问题
  let ImgCompresser;
  // eslint-disable-next-line
  if (typeof __webpack_public_path__ !== 'undefined') {
    // eslint-disable-next-line
    const webpack_public_path = __webpack_public_path__;
    // eslint-disable-next-line global-require
    ImgCompresser = require('html5-image-compress');
    // eslint-disable-next-line
    __webpack_public_path__ = webpack_public_path;
  } else {
    // eslint-disable-next-line global-require
    ImgCompresser = require('html5-image-compress');
  }
  /* eslint-enable */
  return new ImgCompresser(file, options, false);
}

function loadImg(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    if (src.startsWith('data')) {
      img.src = src;
      resolve(img);
    } else {
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => {
        reject();
      };
      img.src = src;
    }
  });
}

export default class Tools {
  static formatCountView(count) {
    if (count >= 10000) {
      const tempCount = (count / 10000).toFixed(1);
      const tempCountArr = tempCount.split('.');
      if (tempCountArr[1] === '0') {
        return `${tempCountArr[0]}w`;
      }
      return `${tempCount}w`;
    }
    return count;
  }

  /**
   * @param {侧边宽度} sideWidth
   * @param {字体大小}} fontSize
   * @param {保留多少行}} lineNum
   * @param {截取多余数量} reduceNum
   */
  static interceptingNumber(sideWidth, fontSize, lineNum, reduceNum) {
    const windowWidth = window.screen.width;
    const wordWidth = (windowWidth / document.body.clientWidth) * fontSize;
    const lineWidth = windowWidth - ((windowWidth / 750) * sideWidth * 2);
    return Math.round((lineWidth / wordWidth) * lineNum) - reduceNum;
  }

  static formatTimeInterval(timestamp) {
    const now = new Date();
    const createDate = new Date(timestamp);
    const diffTime = now.getTime() - timestamp;
    const minuteMillsecond = 60 * 1000;
    const hourMillsecond = 60 * 60 * 1000;
    const dayMillsecond = 24 * 60 * 60 * 1000;
    const hour = Math.floor(diffTime / 1000 / 60 / 60);
    const minute = Math.floor(diffTime / 1000 / 60);
    let result = '';
    if (diffTime > 0) {
      if (diffTime < minuteMillsecond) {
        result = '刚刚';
      } else if (diffTime > minuteMillsecond && diffTime < hourMillsecond) {
        result = `${minute}分钟前`;
      } else if (diffTime > hourMillsecond && diffTime < dayMillsecond) {
        result = `${hour}小时前`;
      } else if (diffTime > dayMillsecond && diffTime < dayMillsecond * 2) {
        result = `昨天${createDate.getHours() < 10 ? `0${createDate.getHours()}` : createDate.getHours()}:${createDate.getMinutes() < 10 ? `0${createDate.getMinutes()}` : createDate.getMinutes()}`;
      } else if (diffTime > dayMillsecond * 2) {
        result = `${createDate.getFullYear()}-${createDate.getMonth() + 1 < 10 ? `0${createDate.getMonth() + 1}` : createDate.getMonth() + 1}-${createDate.getDate() < 10 ? `0${createDate.getDate()}` : createDate.getDate()}`;
      }
    } else {
      result = '未来的某一时刻';
    }
    return result;
  }

  static rc4(key, str) {
    const s = [];
    let i;
    let j = 0;
    let x;
    let res = '';
    for (i = 0; i < 256; i += 1) {
      s[i] = i;
    }
    for (i = 0; i < 256; i += 1) {
      j = (j + s[i] + key.charCodeAt(i % key.length)) % 256;
      x = s[i];
      s[i] = s[j];
      s[j] = x;
    }
    i = 0;
    j = 0;
    for (let y = 0; y < str.length; y += 1) {
      i = (i + 1) % 256;
      j = (j + s[i]) % 256;
      x = s[i];
      s[i] = s[j];
      s[j] = x;
      // eslint-disable-next-line
      res += String.fromCharCode(str.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);
    }
    return res;
  }

  static setCaretPosition(ctrl, pos) { // 设置光标位置函数
    // eslint-disable-next-line no-console
    console.log(ctrl, pos);
    if (ctrl.setSelectionRange) {
      ctrl.focus();
      ctrl.setSelectionRange(pos, pos);
    } else if (ctrl.createTextRange) {
      const range = ctrl.createTextRange();
      range.collapse(true);
      range.moveEnd('character', pos);
      range.moveStart('character', pos);
      range.select();
    }
  }

  static versionCompare(ver1, ver2) {
    const v1 = ver1 || '0.0.0';
    const v2 = ver2 || '0.0.0';
    if (v1 === v2) {
      return 0;
    }
    const v1Arr = v1.split('.');
    const v2Arr = v2.split('.');
    const len = Math.max(v1Arr.length, v2Arr.length);
    for (let i = 0; i < len; i += 1) {
      const v1Item = Number(v1Arr[i] || 0);
      const v2Item = Number(v2Arr[i] || 0);
      if (v1Item < v2Item) {
        return -1;
      }
      if (v1Item > v2Item) {
        return 1;
      }
    }
    return 0;
  }

  static isPlainObject(obj) {
    // 判断是否非window和DOM对象的对象，
    if (!obj || obj.toString() !== '[object Object]' || obj.nodeType || obj.setInterval) {
      return false;
    }

    if (obj.constructor && !Object.prototype.hasOwnProperty.call(obj, 'constructor')
      && !Object.hasOwnProperty.call(obj.constructor.prototype, 'isPrototypeOf')) {
      return false;
    }

    let key;
    Object.keys(obj).forEach((item) => {
      if (Object.prototype.hasOwnProperty.call(obj, item)) {
        key = item;
      }
    });
    return key === undefined;
  }

  static compressImage(file, options) {
    return new Promise((resolve, reject) => {
      try {
        createImgCompresser(file, {
          quality: 0.8,
          done(originalFile, base64) {
            resolve({ originalFile, base64 });
          },
          fail() {
            reject(new Error('压缩失败'));
          },
          notSupport() {
            reject(new Error('浏览器不支持'));
          },
          ...options,
        });
      } catch (e) {
        reject(new Error(e));
      }
    });
  }

  static getRandomIntInclusive(min, max) {
    const minCeil = Math.ceil(min);
    const MaxFloor = Math.floor(max);
    return Math.floor(Math.random() * ((MaxFloor - minCeil) + 1)) + minCeil;
  }

  static imgLoadPromise(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      if (img.complete) {
        resolve(img);
      }
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => {
        // todo 不改
        // reject();
        resolve(img);
      };
    });
  }

  static setUrlParams(originUrl, param, value) {
    let result;
    const url = this.removeParams(param, originUrl);
    if (url.indexOf('?') !== -1) {
      const p = new RegExp('(\\?|&" + param + ")=[^&]*');
      if (p.test(url)) {
        result = url.replace(p, `$1=${value}`);
      } else {
        result = `${url}&${param}=${value}`;
      }
    } else {
      result = `${url}?${param}=${value}`;
    }
    return result;
  }

  static removeParams(keyName, urlStr) {
    // eslint-disable-next-line
    const name = keyName.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*(&|#|$))|&|#|$)`);
    return urlStr.replace(regex, (item) => {
      if (/^\?/.test(item)) {
        return '?';
      } if (/^&.+&$/.test(item)) {
        return '&';
      } if (/#$/.test(item)) {
        return '#';
      }
      return '';
    });
  }

  static transformQueryString(params) {
    const _params = {
      ...params,
    };
    delete _params.token;
    delete _params.phone;
    return `?${Object.keys(_params).map((key) => `${key}=${_params[key]}`).join('&')}`;
  }


  static async canvertImage(imgSrcList, options = { ratio: 1 }) {
    if (document) {
      const canvas = document.createElement('canvas');
      canvas.width = 375 * options.ratio;
      canvas.height = 667 * options.ratio;
      const ctx = canvas.getContext('2d');
      const imgList = await Promise.all(imgSrcList.map((v) => loadImg(v.src)));
      imgList.forEach((v, i) => {
        const {
          x, y, width, height,
        } = imgSrcList[i];
        ctx.drawImage(v, x, y, width, height);
      });
      return canvas.toDataURL();
    }
    return new Error('环境错误');
  }

  static imgCompress(imgBase64, scale, filetype) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imgBase64;
      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const canvasWidth = image.width * scale;
          const canvasHeight = image.height * scale;
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;
          context.drawImage(
            image, 0, 0, image.width, image.height, 0, 0, canvasWidth, canvasHeight,
          );
          resolve(canvas.toDataURL(filetype || 'image/jpeg'));
        } catch (error) {
          reject(error);
        }
      };
    });
  }

  static base64ToBlob(b64data, contentType, sliceSizeParam) {
    const sliceSize = sliceSizeParam || 512;
    return new Promise((resolve) => {
      try {
        // 使用 atob() 方法将数据解码
        const byteCharacters = window.atob(b64data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = [];
          for (let i = 0; i < slice.length; i += 1) {
            byteNumbers.push(slice.charCodeAt(i));
          }
          // 8 位无符号整数值的类型化数组。内容将初始化为 0。
          // 如果无法分配请求数目的字节，则将引发异常。
          byteArrays.push(new Uint8Array(byteNumbers));
        }
        resolve(new Blob(byteArrays, {
          type: contentType,
        }));
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('base64ToBlob', e);
        resolve({
          size: b64data.length,
        });
      }
    });
  }

  static sendUbtPv(pageName, payload) {
    const currentEnvName = Tools.getCurrentEnvName();
    UBTHelper.pageView({
      categoryId: '顺风车',
      pageId: `${currentEnvName}_顺风车_${pageName}`,
      ...payload,
    });
  }

  static sendUbtClickBtn(pageName, buttonName, payload) {
    const currentEnvName = Tools.getCurrentEnvName();
    UBTHelper.pageView({
      categoryId: '顺风车',
      pageId: `${currentEnvName}_顺风车_${pageName}`,
      buttonName: `${currentEnvName}_顺风车_${buttonName}`,
      ...payload,
    });
  }

  static getCurrentEnvName() {
    if (env.isAliMP) {
      return 'Alipay';
    }
    if (env.isEasyBikeApp || env.isHitchIndepApp) {
      return 'APP';
    }
    if (env.isWeixinMp) {
      return 'WeChat';
    }
    return 'H5';
  }

  static openApp(appSchema) {
    window.location.href = appSchema;
    window.setTimeout(() => {
      let url = `https://c3x.me/freeride.html?redirectUrl=${encodeURIComponent(appSchema)}`;
      if (env.isWeixin) { // 微信下
        url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.jingyao.easybike';
      }
      window.location.href = url;
    }, 1000);
  }
}
